import { render, staticRenderFns } from "./PortalEmployeeGroups.vue?vue&type=template&id=c0cbffb6&"
import script from "./PortalEmployeeGroups.vue?vue&type=script&lang=js&"
export * from "./PortalEmployeeGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports